import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import favicon from '../images/favicon-32x32.png';
import Helmet from 'react-helmet';
import Hamburger from './hamburger';
import $ from 'jquery';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/main.css';

export default class Header extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			menuToggle: false,
			classname: 'header',
			bannerToggle: this.props.hide ? "none" : "block"
		};
	}

	handleMenuClick() {
		this.setState((prevState) => {
			return { menuToggle: !prevState.menuToggle };
		});

		if (this.state.classname === 'header') {
			this.setState({ classname: 'header is-open' });
		} else {
			this.setState({ classname: 'header' });
		}

		$(this.refs['toggle-div']).slideToggle();
	}

	//TODO ?
	handleLinkClick() {
		this.setState({ menuToggle: false });
	}

	render() {
		return (
			<header>
				<div>
					<div>
						<div className="col-12">
							<div>
								<nav>
									<ul ref="toggle-div" className="header__menu">
										<li>
											<Link to="/">HOME</Link>
										</li>
										<li>
											<Link to="/start">GET STARTED</Link>
										</li>
										<li>
											<Link to="/services">SERVICES</Link>
										</li>
										<li>
											<Link to="/about">ABOUT LAN</Link>
										</li>
										<li>
											<Link to="/contactus">CONTACT</Link>
										</li>
									</ul>
								</nav>
								<div className="header__group">
									<Hamburger open={this.state.menuToggle} onClick={() => this.handleMenuClick()} />
								</div>

								<Helmet>
									<link rel="icon" href={favicon} />
								</Helmet>
							</div>
						</div>
					</div>
					<section className="banner" style={{display: this.state.bannerToggle}}>
						<div className="row" style={{ display: 'flex', flexWwrap: 'wrap', padding: '0' }}>
							<div className="column" style={{ flex: '25%', maxWidth: '25%', padding: '0' }}>
								<img
									className="avatar profile-image img-fluid img-right rounded-circle"
									src={require(`../images/lan.jpg`)}
									alt="Lan"
								/>
							</div>
						</div>
						<div className="banner-text">
							<h1 className="site-title">Lan Linville Drafting</h1>
							<h2 className="desc">Serving the Greater Sacramento area</h2>
						</div>
					</section>
				</div>
			</header>
		);
	}
}

Header.propTypes = {
	siteTitle: PropTypes.string
};

Header.defaultProps = {
	siteTitle: ``
};
